import { getMarketAppConfig, isPortugalMarket } from '../config/marketRegion';

export function taxIdLabel(): string {
  return getMarketAppConfig().tax_id_label;
}

export function taxIdGuardianLabel(): string {
  return getMarketAppConfig().tax_id_guardian_label;
}

export function taxIdRequiredLabel(): string {
  return `${taxIdLabel()} *`;
}

export function patientTaxIdDuplicateTitle(): string {
  return isPortugalMarket() ? 'NIF já cadastrado' : 'CPF já cadastrado';
}

export function patientTaxIdDuplicateMessage(): string {
  return isPortugalMarket()
    ? 'O NIF informado já pertence a outro paciente no sistema. Verifique se digitou corretamente ou busque o cadastro existente antes de continuar.'
    : 'O CPF informado já pertence a outro paciente no sistema. Verifique se digitou corretamente ou busque o cadastro existente antes de continuar.';
}

export function patientTaxIdRequiredMessage(): string {
  return `${taxIdLabel()} é obrigatório`;
}

export function formatTaxIdInput(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (isPortugalMarket()) {
    const d = digits.slice(0, 9);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)} ${d.slice(3)}`;
    return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
  }
  const d = digits.slice(0, 14);
  if (d.length <= 11) {
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
    if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export function formatTaxIdDisplay(digits: string | null | undefined): string {
  if (!digits) return '';
  return formatTaxIdInput(String(digits).replace(/\D/g, ''));
}

/** Rótulo para HTML/PDF: «CPF:» ou «NIF:». */
export function taxIdColonLabel(): string {
  return `${taxIdLabel()}:`;
}

export function patientSearchPlaceholder(): string {
  return `Buscar por nome, ${taxIdLabel()} ou telefone...`;
}

export function patientSearchNoOptionsHint(): string {
  return `nome, ${taxIdLabel()} ou telefone`;
}

export function formatPatientTaxIdOption(value: string): string {
  return `${taxIdColonLabel()} ${value}`;
}

/** Máscara parcial para sugestão de vínculo inbox (privacidade). */
export function maskCandidateTaxId(value?: string | null): string | null {
  const digits = String(value || '').replace(/\D/g, '');
  if (isPortugalMarket()) {
    if (digits.length !== 9) return null;
    return `*** ${digits.slice(3, 6)} ${digits.slice(6, 8)}*`;
  }
  if (digits.length !== 11) return null;
  return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`;
}
